export default "__VITE_ASSET__WyKbbgA9__"